import { DateTime } from 'luxon';

import { request } from './request';
import { getMerchantId, getUserId } from './user.service';
import { parseObjectToQueryParamString } from 'src/helpers/functional-helpers';

export async function getSettlements(
  localTransactionFromDate,
  localTransactionToDate,
  abortController,
  pageNumber,
  handleErrorResponse = null,
  showToastOnError = true,
  suppressTealiumEvent = false,
) {
  const userId = getUserId();
  const merchantId = getMerchantId();
  const queryParams = {
    userReference: userId,
    merchantID: merchantId,
    processingFromDate:
      DateTime.fromJSDate(localTransactionFromDate).toFormat('yyyy-MM-dd HH:mm:ss'),
    processingToDate: DateTime.fromJSDate(localTransactionToDate).toFormat('yyyy-MM-dd HH:mm:ss'),
    channelId: 'WEB',
    channelName: 'Vodacom',
  };

  queryParams.settlementConfirmations = 99;
  // if (fromAmount !== undefined && fromAmount !== null) {
  //   queryParams.transactionFromAmount = fromAmount;
  // }
  // if (toAmount !== undefined && toAmount !== null) {
  //   queryParams.transactionToAmount = toAmount;
  // }
  // if (!!reference) {
  //   queryParams.retrievalReference = reference;
  // }
  // if (!!response && !response.startsWith('All')) {
  //   queryParams.responseCodeDescription = response;
  // }
  // if (!!transactionType && !transactionType.startsWith('All')) {
  //   queryParams.transactionTypeCode = transactionType;
  // }
  if (!!pageNumber) {
    queryParams.pageNumber = pageNumber;
  }

  const res = await request(
    `account-transactions?${parseObjectToQueryParamString(queryParams)}`,
    {
      fetchOptions: {
        method: 'GET',
        signal: abortController.signal,
      },
    },
    null,
    null,
    showToastOnError,
    suppressTealiumEvent,
  );

  const isAborted = !!abortController && abortController.signal.aborted;
  if (res?.status === 200) {
    return res.result || [];
  } else if (handleErrorResponse && !isAborted) {
    handleErrorResponse(
      'error response from the account-transactions GET endpoint (settlements)',
      true,
      suppressTealiumEvent,
      res,
    );
  }
}

export async function getTransactions(
  settlementUUID,
  localTransactionFromDate,
  localTransactionToDate,
  abortController,
  pageNumber,
  reference = null,
  fromAmount = null,
  toAmount = null,
  transactionType = null,
  handleErrorResponse = null,
  showToastOnError = true,
  suppressTealiumEvent = false,
) {
  const userId = getUserId();
  const merchantId = getMerchantId();
  const queryParams = {
    userReference: userId,
    merchantID: merchantId,
    channelId: 'WEB',
    channelName: 'Vodacom',
  };

  let isSearchOrFilter = false;
  if (fromAmount !== undefined && fromAmount !== null) {
    queryParams.transactionFromAmount = fromAmount;
    isSearchOrFilter = true;
  }
  if (toAmount !== undefined && toAmount !== null) {
    queryParams.transactionToAmount = toAmount;
    isSearchOrFilter = true;
  }
  if (!!reference) {
    queryParams.retrievalReferenceNumber = reference;
    isSearchOrFilter = true;
  }

  if (!!transactionType && !transactionType.startsWith('All')) {
    queryParams.transactionTypeCode = transactionType;
    isSearchOrFilter = true;
  }

  if (!!settlementUUID) {
    queryParams.settlementConfirmationUUID = !isSearchOrFilter ? settlementUUID : undefined;
  } else {
    queryParams.processingFromDate =
      DateTime.fromJSDate(localTransactionFromDate).toFormat('yyyy-MM-dd');
    queryParams.processingToDate =
      DateTime.fromJSDate(localTransactionToDate).toFormat('yyyy-MM-dd');
  }

  if (!!pageNumber) {
    queryParams.pageNumber = pageNumber;
  }

  const res = await request(
    `account-transactions?${parseObjectToQueryParamString(queryParams)}`,
    {
      fetchOptions: {
        method: 'GET',
        signal: abortController.signal,
      },
    },
    null,
    null,
    showToastOnError,
    suppressTealiumEvent,
  );

  const isAborted = !!abortController && abortController.signal.aborted;
  if (res?.status === 200) {
    return res.result || [];
  } else if (handleErrorResponse && !isAborted) {
    handleErrorResponse(
      'error response from the account-transactions GET endpoint (transactions)',
      true,
      suppressTealiumEvent,
      res,
    );
  }
}
